var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CardLarge',{staticClass:"center"},[_c('header',[_vm._v(_vm._s(_vm.header))]),_c('ul',_vm._l((_vm.results),function(item){return _c('Party',{key:item.partyId,attrs:{"item":item}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }